// removed by extract-text-webpack-plugin
module.exports = {"closeButton":"_3A7oo"};


//////////////////
// WEBPACK FOOTER
// ./app/containers/login-page/login-page.scss
// module id = 1637
// module chunks = 0